import React from "react";
import { Box, FormControlLabel, Switch, TextField, Typography } from "@mui/material";
import LockScreenPreview from "../previews/LockScreenPreview";

// NOTIF-12 AC6 — exact wording isn't mandated (context.md "Exact copy wording"),
// but it must state that push ignores the recipient's own mute/notification
// preferences, and stay adjacent to the toggle regardless of its position.
export const PUSH_BYPASS_COPY =
  "Push notifications bypass the recipient's mute and notification preferences.";

export default function PushStep({ state, dispatch, errors = {} }) {
  const setField = (field) => (event) =>
    dispatch({ type: "SET_FIELD", field, value: event.target.value });

  const handleToggle = (event) => {
    const checked = event.target.checked;
    dispatch({ type: "SET_FIELD", field: "send_push_notification", value: checked });

    // Toggling off leaves no push field state behind (NOTIF-11 AC5, UI half —
    // buildPayload already omits push keys when the flag is off, T5). Without
    // this, re-enabling the toggle would resurface stale title/subtitle text.
    if (!checked) {
      dispatch({ type: "SET_FIELD", field: "push_title", value: "" });
      dispatch({ type: "SET_FIELD", field: "push_subtitle", value: "" });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <FormControlLabel
        control={<Switch checked={state.send_push_notification} onChange={handleToggle} />}
        label="Send push notification"
      />
      <Typography variant="body2" color="text.secondary">
        {PUSH_BYPASS_COPY}
      </Typography>

      {state.send_push_notification && (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", flexWrap: "wrap" }}>
          <Box sx={{ flex: 1, minWidth: 240, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Push title"
              value={state.push_title}
              onChange={setField("push_title")}
              error={Boolean(errors.push_title)}
              helperText={errors.push_title || " "}
              fullWidth
            />
            <TextField
              label="Push subtitle (optional)"
              value={state.push_subtitle}
              onChange={setField("push_subtitle")}
              fullWidth
            />
          </Box>

          {/* NOTIF-25 AC3 — unmounted along with the fields above when push is off */}
          <LockScreenPreview push_title={state.push_title} push_subtitle={state.push_subtitle} />
        </Box>
      )}
    </Box>
  );
}
